<div class="title-container">
  <h3 class="title">
    {{ 'Reports.PortfolioReport.BusinessSectorDistribution' | translate }}
  </h3>
  <hr class="separation-line" />
</div>

<div class="chart-container">
  <div class="canvas">
    <canvas [id]="canvasId"></canvas>
  </div>

  <div class="legend">
    <label *ngFor="let label of legend">
      {{label}}
    </label>
  </div>
</div>
